"use client";

import React from "react";
import { BsMoon, BsSun } from "react-icons/bs";
import { useTheme } from "@/context/theme-context";

export default function ThemeSwitch() {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      className="fixed bottom-5 right-5 z-50
        w-10 h-10
        rounded-full
        bg-[var(--color-surface-raised)]/90
        backdrop-blur-md
        border border-[var(--color-border)]
        text-[var(--color-text-secondary)]
        flex items-center justify-center
        hover:text-[var(--color-brand)] hover:border-[var(--color-brand)]
        transition-colors duration-200
        shadow-sm
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-brand)]"
      title={theme === "light" ? "Switch to dark mode" : "Switch to light mode"}
      onClick={toggleTheme}
    >
      {theme === "light"
        ? <BsMoon className="w-4 h-4" />
        : <BsSun className="w-4 h-4" />}
    </button>
  );
}
